export default {
      id: "ic_fleche_bouton-usage",
      viewBox: "0 0 20 20",
      url: "../dist/images/" + "sprite.svg#ic_fleche_bouton-usage",
      toString: function () {
        return this.url;
      }
    }